import { render } from "./ListaCategorias.vue?vue&type=template&id=5a52ef8c&scoped=true"
import script from "./ListaCategorias.vue?vue&type=script&lang=js"
export * from "./ListaCategorias.vue?vue&type=script&lang=js"

import "./ListaCategorias.vue?vue&type=style&index=0&id=5a52ef8c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a52ef8c"]])

export default __exports__